import { shape, string } from 'prop-types';

export const option = shape({ label: string, value: string });
